define([
    'bignumber.js',
    'appcontext'
], (BigNumber, appContext) => ({
    initNumeric (scope) {
        const nbsp = String.fromCharCode(160);
        const delimeters = appContext.numeralDelimeters().get();
        const minLimit = '-99999999999999.00000000';
        const maxLimit = '99999999999999.00000000';
        const zeroLimit = '0.00000000';

        _.each(scope.hasClass('numeric') ? [scope] : scope.find('.numeric'), (el) => {
            const $el = $(el);
            const isInput = $el.is('input');
            const fun = isInput ? 'val' : 'text';
            let text = $el[fun]();
            const data = $el.data();
            const classes = {};

            _.each(($el.attr('class') || '').split(' '), (cls) => {
                classes[cls] = true;
            });

            $el.autoNumeric('destroy');
            $el[fun]('');

            // workaround with integer null-value empty cell formatting
            if (!isInput && classes.integer && text === 'null') {
                text = '';
            }

            if (text && text.length || isInput) {

                // Specify default format options for all classes
                const format = {
                    aSep: delimeters.thousands.replace(' ', nbsp),
                    aDec: delimeters.decimal,
                    vMin: zeroLimit,
                    vMax: maxLimit,
                    mRound: 'B'
                }; let symbol;

                const vatDate = $el.data('vat-date');
                format.vatDivider = appContext.getVatDividerForDate(vatDate);

                // Each CSS class provides its own subset of default options
                if (classes.currency) {
                    _.extend(format, {mDec: 2});
                    if (classes.symbol) {
                        symbol = appContext.currencySymbol(appContext.accountCurrency()) || '';
                        _.extend(format, {aSign: nbsp + symbol, pSign: 's'});
                    }
                } else if (classes.integer) {
                    _.extend(format, {mDec: 0});
                } else if (classes.percent) {
                    _.extend(format, {mDec: 2, aSign: '%', pSign: 's', vMax: '100.00', aPad: false});
                } else if (classes.decimal) {
                    _.extend(format, {mDec: 2});
                } else {
                    console.error('Unknown format for numeric ', $el);
                }

                // If element is not input we don't use any limits
                if (!isInput) {
                    _.extend(format, {vMin: minLimit, vMax: maxLimit});
                }

                // We can override some of format options via element data attributes
                const min = data.min; const max = data.max; const dec = data.dec; const pad = data.pad;
                const currencyId = data.currencyId;
                let value;
                symbol = data.currencySymbol;

                if (!_.isUndefined(min)) {
                    format.vMin = _.isNull(min) ? minLimit : min;
                }
                if (!_.isUndefined(max)) {
                    format.vMax = _.isNull(max) ? maxLimit : max;
                }
                if (!_.isUndefined(dec)) {
                    format.mDec = dec;
                }
                if (!_.isUndefined(pad)) {
                    format.aPad = pad;
                }
                if (!_.isUndefined(symbol)) {
                    _.extend(format, {aSign: nbsp + symbol, pSign: 's'});
                } else if (!_.isUndefined(currencyId)) {
                    symbol = appContext.currencySymbol(appContext.currencies().get(currencyId)) || '';
                    _.extend(format, {aSign: nbsp + symbol, pSign: 's'});
                }

                // Now initialize autoNumeric with our format options
                $el.autoNumeric('init', format);

                value = text;

                // Deal with VAT
                if (classes.vat) {
                    const withVat = appContext.withVat();
                    const vatDivider = format.vatDivider || new BigNumber(1);

                    value = new BigNumber(value || 0);
                    value = withVat ? value.times(vatDivider) : value;
                    value = value.toFixed(2);
                }

                $el.autoNumeric('set', value);

            } else {
                el.innerHTML = !_.isUndefined(data.empty) ? data.empty : '&mdash;';
            }
        });
    }
}));

